module.exports = __webpack_public_path__ + "assets/images/project/china.jpg?v=122c14c5";